<template>
  <div>
    <v-snackbar top :timeout="3000" v-model="snackbar">{{
      snackbarText
    }}</v-snackbar>
    <v-card class="d-flex flex-column">
      <v-card-title class="grid-close">
        <span class="headline">Ingresar MFA Token</span>
        <v-btn
          style="right: 10px; top: 10px"
          icon
          color="primary"
          fab
          absolute
          @click="$emit('cancel')"
          v-if="!loading"
        >
          <v-icon dark>fa-times</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-container fluid>
          <v-row class="pa-0 ma-0">
            <span class="font-weight-bold"
              >Abra la aplicación generadora de Token en su celular e ingréselo
              en el siguiente campo de texto</span
            >
            <v-col cols="12" sm="12" md="12">
              <v-text-field
                v-model="token"
                label="Token MFA"
                v-on:keyup.enter="submit"
                @keypress="maxLength($event, token)"
                class="mt-3"
                name="input-10-1"
                rounded
                filled
                autofocus
                clearable
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row class="pa-0 ma-0">
            <v-col cols="12" sm="12" md="12">
              <v-row justify="end">
                <v-btn
                  :loading="loading"
                  block
                  large
                  @click="submit"
                  color="btn-color"
                  >Aceptar</v-btn
                >
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "Token",
  data() {
    return {
      loading: false,
      snackbarText: "",
      snackbar: false,
      token: "",
    };
  },
  methods: {
    submit() {
      if (!this.token && this.token.length != 6) {
        this.snackbarText = "Debe ingresar un código de 6 digitos.";
        this.snackbar = true;
      } else {
        this.loading = true;
        this.$emit("insertedToken", this.token);
      }
    },
    cancel() {
      this.loading = false;
    },
    tokenError() {
      this.snackbarText = "Token inválido";
      this.snackbar = true;
      this.loading = false;
    },
    handleSuccess() {
      this.loading = false;
      this.token = "";
      this.$emit("cancel");
    },
    maxLength(evt, field) {
      var keycode = event.which;
      if (
        field.length < 6 &&
        evt.shiftKey == false &&
        (keycode == 46 ||
          keycode == 8 ||
          keycode == 37 ||
          keycode == 39 ||
          (keycode >= 48 && keycode <= 57))
      )
        return true;
      else evt.preventDefault();
    },
  },
};
</script>